import {
    ApplicationInsights,
    DistributedTracingModes,
    ITelemetryItem,
} from '@microsoft/applicationinsights-web';

const addOneDsTelemetry = (
    instrumentKey: string,
    appName: string = '',
): ApplicationInsights => {
    let appInsights: any;
    if (instrumentKey) {
        appInsights = new ApplicationInsights({
            config: {
                instrumentationKey: instrumentKey,
                distributedTracingMode: DistributedTracingModes.AI_AND_W3C,
                disableFetchTracking: false,
                enableAutoRouteTracking: true,
                enableCorsCorrelation: true,
            },
        });
        appInsights.loadAppInsights();
        appInsights.trackPageView();
        appInsights.addTelemetryInitializer((telemetry: ITelemetryItem) => {
            const defaultRoleName = 'App';
            const role = { 'ai.cloud.role': appName || defaultRoleName };
            telemetry.tags?.push(role);
        });
    }
    return appInsights;
};

export default addOneDsTelemetry;
